import loadable from '@wix/yoshi-flow-editor/loadable';
import type { FC } from 'react';
import React, { useEffect } from 'react';

import { useUI, useUIHandlers } from '../widgets';

const Toast = loadable(
  () =>
    import(
      /* webpackChunkName: "Toast" */ '../../components/Profile/Widget/common/Toast'
    ),
);

const toastFadeOutDelay = 5000;

export const ToastContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { toast } = useUI();
  const { hideToast } = useUIHandlers();

  useEffect(() => {
    if (toast.isVisible) {
      const timeout = setTimeout(hideToast, toastFadeOutDelay);
      return () => clearTimeout(timeout);
    }
  }, [toast.isVisible, hideToast]);

  return (
    <>
      <Toast />
      {children}
    </>
  );
};
